import { nullishToOptional } from "../../helpers";
import { DesignTokenType } from "../elements";
import { ImportWarning } from "../import/warning";
import { DataSourceFigmaErrorType, DataSourceFigmaState } from "./enums";
import { z } from "zod";
export const FileStructureStats = z.object({
    frames: zeroNumberByDefault(),
    components: zeroNumberByDefault(),
    componentSets: zeroNumberByDefault(),
});
// With backward compatibility
const SourceImportSummaryByTokenTypeKey = DesignTokenType.or(z.enum(["Measure", "Radius", "GenericToken", "Font", "Text"]));
export const SourceImportSummaryByTokenType = z.record(SourceImportSummaryByTokenTypeKey, z.number());
export const SourceImportTokenSummary = z.object({
    tokensCreated: zeroNumberByDefault(),
    tokensUpdated: zeroNumberByDefault(),
    tokensDeleted: zeroNumberByDefault(),
    tokensCreatedPerType: SourceImportSummaryByTokenType.nullish().transform((v) => v !== null && v !== void 0 ? v : {}),
    tokensUpdatedPerType: SourceImportSummaryByTokenType.nullish().transform((v) => v !== null && v !== void 0 ? v : {}),
    tokensDeletedPerType: SourceImportSummaryByTokenType.nullish().transform((v) => v !== null && v !== void 0 ? v : {}),
});
export const SourceImportComponentSummary = z.object({
    componentsCreated: zeroNumberByDefault(),
    componentsUpdated: zeroNumberByDefault(),
    componentsDeleted: zeroNumberByDefault(),
    componentAssetsCreated: zeroNumberByDefault(),
    componentAssetsUpdated: zeroNumberByDefault(),
    componentAssetsDeleted: zeroNumberByDefault(),
});
export const SourceImportStorybookSummary = z.object({
    created: zeroNumberByDefault(),
    updated: zeroNumberByDefault(),
    deleted: zeroNumberByDefault(),
});
export const SourceImportFrameSummary = z.object({
    assetsInFile: nullishToOptional(FileStructureStats.optional()),
    invalidReferencesCount: nullishToOptional(z.number().optional()),
});
export const SourceErrorRateLimitDetails = z.object({
    retryAfter: z.number().optional(),
    figmaPlanTier: z.string().optional(),
    rateLimitType: z.string().optional(),
});
export const SourceError = z.object({
    /** @deprecated use error type instead */
    cloudState: DataSourceFigmaState,
    /**
     * @deprecated rely on additional properties like `rateLimitDetails` instead,
     * if consider adding more properties on the backend side
     */
    originalError: nullishToOptional(z.record(z.any())),
    errorType: DataSourceFigmaErrorType.optional(),
    rateLimitDetails: SourceErrorRateLimitDetails.optional(),
});
export const SourceImportSummary = z.object({
    sourceId: nullishToOptional(z.string()),
    brandId: nullishToOptional(z.string()),
    versionId: nullishToOptional(z.string()),
    error: nullishToOptional(SourceError),
    isFailed: z.boolean(),
    warnings: z
        .array(ImportWarning)
        .nullish()
        .transform((v) => v !== null && v !== void 0 ? v : []),
    ...SourceImportTokenSummary.shape,
    ...SourceImportComponentSummary.shape,
    ...FileStructureStats.shape,
});
function zeroNumberByDefault() {
    return z
        .number()
        .nullish()
        .transform((v) => v !== null && v !== void 0 ? v : 0);
}
